import type { ExtFeatureKey } from '@slims-pro/client-config';
import { AccessDeniedScreen } from '@slims-pro/ui/organisms';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useMe } from '@/hooks/use-me';
import { useMeta } from '@/hooks/use-meta';
import { RouterLink } from '@/lib/router-link';
import type { ModuleId } from '@/modules/registry';

/**
 * Extension key not enabled → home; `module` set and not permitted → access denied. The SPA does
 * not know `x.` policies: the API enforces them and the page handles its 403.
 */
export function RequireExtension({
	feature,
	module,
	children,
}: {
	feature: ExtFeatureKey;
	module?: ModuleId;
	children: ReactNode;
}) {
	const meta = useMeta().data; // loaded by ProtectedRoute, never undefined here
	const me = useMe().data;
	if (!meta?.features.includes(feature)) return <Navigate to="/" replace />;
	if (module && !me?.permissions.some((p) => p.module === module)) {
		return <AccessDeniedScreen actionHref="/" linkComponent={RouterLink} />;
	}
	return children;
}
